"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStepElement = exports.setSteps = exports.resetModal = exports.fillModal = void 0;
const utils_1 = require("./utils");
const modal = document.querySelector('.integration');
const integrationImg = modal === null || modal === void 0 ? void 0 : modal.querySelector('.integration__logo-img');
const title = modal === null || modal === void 0 ? void 0 : modal.querySelector('.integration__title');
const desc = modal === null || modal === void 0 ? void 0 : modal.querySelector('.integration__desc');
const boxVersion = modal === null || modal === void 0 ? void 0 : modal.querySelector('.integration__detail-ver');
const boxPlatform = modal === null || modal === void 0 ? void 0 : modal.querySelector('.integration__detail-platform');
const boxAuthor = modal === null || modal === void 0 ? void 0 : modal.querySelector('.integration__detail-author');
const boxPrice = modal === null || modal === void 0 ? void 0 : modal.querySelector('.integration__detail-price');
const integrationBtn = modal === null || modal === void 0 ? void 0 : modal.querySelector('.integration__button--blue');
const contactBtn = modal === null || modal === void 0 ? void 0 : modal.querySelector('.integration__button--green');
const installation = document.querySelector('.integration__info-installation');
const infoInstallation = document.querySelector('.integration__info-instal');
const changelog = document.querySelector('.integration__info-changelog');
const scopeWrapper = document.querySelector('.integration__scope-lists');
const scopesAside = document.querySelector('.integration__scope');
const fillModal = (integration) => {
    var _a, _b, _c;
    let details;
    try {
        details = JSON.parse(integration.details.value);
    }
    catch (error) {
        console.error("Failed to parse integration details:", error);
        return;
    }
    const changeLogDate = ((_a = details.changeLogs) === null || _a === void 0 ? void 0 : _a.length) > 0 ? (0, utils_1.formatDate)((_b = details.changeLogs[0]) === null || _b === void 0 ? void 0 : _b.date) : '';
    if (!modal)
        return;
    title && desc && setBasicInfo(integrationImg, title, desc, integration.icon_url, integration.name, integration.short_desc);
    integrationBtn && contactBtn && setIntegrationButtons(integrationBtn, contactBtn, (_c = details.data) === null || _c === void 0 ? void 0 : _c.helpUrl);
    setDetailsBoxes({ boxVersion, boxPlatform, boxAuthor, boxPrice }, details.data, changeLogDate);
    (0, exports.setSteps)(details.steps);
    setChangeLogs(details.changeLogs);
    setScopes(details.scopes);
};
exports.fillModal = fillModal;
const resetModal = () => {
    if (!modal)
        return;
    integrationImg === null || integrationImg === void 0 ? void 0 : integrationImg.setAttribute("src", "");
    title && (title.innerHTML = "");
    desc && (desc.innerHTML = "");
    (0, utils_1.resetBox)(boxVersion, "VERSION");
    (0, utils_1.resetBox)(boxPlatform, "PLATFORM VERSION");
    (0, utils_1.resetBox)(boxAuthor, "AUTHOR");
    (0, utils_1.resetBox)(boxPrice, "PRICE");
    integrationBtn && (integrationBtn.style.display = "none");
    contactBtn && (contactBtn.style.display = "none");
    if (installation)
        installation.innerHTML = '';
    if (infoInstallation)
        infoInstallation.classList.add("d-none");
    if (changelog)
        changelog.innerHTML = '';
    if (scopeWrapper)
        scopeWrapper.innerHTML = '';
    if (scopesAside)
        scopesAside.classList.add("d-none");
};
exports.resetModal = resetModal;
const setBasicInfo = (img, title, desc, iconUrl, name, shortDesc) => {
    if (img)
        img.setAttribute("src", iconUrl);
    if (title)
        title.innerHTML = name;
    if (desc)
        desc.innerHTML = shortDesc;
};
const setIntegrationButtons = (integrationBtn, contactBtn, helpUrl) => {
    if (integrationBtn) {
        integrationBtn.style.display = helpUrl ? "block" : "none";
        if (helpUrl) {
            integrationBtn.setAttribute("href", helpUrl);
        }
    }
    if (contactBtn) {
        contactBtn.style.display = "block";
        contactBtn.setAttribute("href", "https://www.salesmanago.com/info/requestdemo.htm");
    }
};
const setDetailsBoxes = (elements, data, changeLogDate) => {
    var _a;
    const { boxVersion, boxPlatform, boxAuthor, boxPrice } = elements;
    updateBox(boxVersion, data.version, "info-square--grey", changeLogDate);
    updateBox(boxPlatform, data.platformVersion, "info-square--grey");
    updateBox(boxAuthor, (_a = data.publisher) === null || _a === void 0 ? void 0 : _a.replace(/&/g, " & "), "info-square--grey");
    updateBox(boxPrice, data.price, "info-square--grey");
};
const updateBox = (element, content, contentClass, additionalContent) => {
    if (element && content) {
        const square = createInfoSquare(content, contentClass, additionalContent);
        element.style.display = "block";
        element.appendChild(square);
    }
    else if (element) {
        element.style.display = "none";
    }
};
const createInfoSquare = (content, contentClass, additionalContent) => {
    const square = document.createElement("div");
    square.classList.add("info-square", contentClass);
    const contentElement = document.createElement("p");
    contentElement.innerHTML = content;
    square.appendChild(contentElement);
    if (additionalContent) {
        const additionalElement = document.createElement("p");
        additionalElement.classList.add("info-square-date");
        additionalElement.innerHTML = additionalContent;
        square.appendChild(additionalElement);
    }
    return square;
};
const setSteps = (steps) => {
    if (!installation || !infoInstallation)
        return;
    if (steps.length > 0) {
        infoInstallation.classList.remove("d-none");
        const fragment = document.createDocumentFragment();
        steps.forEach((step, index) => fragment.appendChild((0, exports.createStepElement)(index + 1, step)));
        installation.appendChild(fragment);
    }
    else {
        infoInstallation.classList.add("d-none");
    }
};
exports.setSteps = setSteps;
const createStepElement = (index, description) => {
    const stepElement = (0, utils_1.createIntegrationElements)("div", "integration__info-ele");
    const square = (0, utils_1.createIntegrationElements)("div", "info-square info-square--blue", index.toString());
    const stepDescription = (0, utils_1.createIntegrationElements)("p", "integration__info-desc", description);
    stepElement.append(square, stepDescription);
    return stepElement;
};
exports.createStepElement = createStepElement;
const setChangeLogs = (changeLogs) => {
    if (changelog) {
        if (changeLogs.length > 0) {
            changeLogs.forEach(log => changelog.appendChild(createChangeLogElement(log)));
        }
        else {
            const noUpdateElement = (0, utils_1.createIntegrationElements)("div", "integration__info-ele", "There are no recent updates");
            changelog.appendChild(noUpdateElement);
        }
    }
};
const createChangeLogElement = (log) => {
    const logElement = (0, utils_1.createIntegrationElements)("div", "integration__info-ele integration__info-changelog-ele");
    const aside = (0, utils_1.createIntegrationElements)("div", "integration__info-changelog-ele-aside");
    const square = (0, utils_1.createIntegrationElements)("div", "info-square info-square--orange");
    const label = (0, utils_1.createIntegrationElements)("h3", "integration__detail-label", "VERSION");
    const version = (0, utils_1.createIntegrationElements)("p", undefined, log.version);
    const dateLabel = (0, utils_1.createIntegrationElements)("p", undefined, (0, utils_1.formatDate)(log.date));
    const description = (0, utils_1.createIntegrationElements)("div", "integration__info-changelog-desc", log.description);
    square.appendChild(version);
    square.appendChild(dateLabel);
    aside.appendChild(label);
    aside.appendChild(square);
    logElement.appendChild(aside);
    logElement.appendChild(description);
    return logElement;
};
const setScopes = (scopes) => {
    if (scopeWrapper) {
        scopesAside === null || scopesAside === void 0 ? void 0 : scopesAside.classList.remove("d-none");
        if (scopes.length > 0) {
            scopes.forEach(scope => {
                const scopeElement = createScopeElement(scope);
                scopeWrapper.appendChild(scopeElement);
            });
        }
        else {
            scopesAside === null || scopesAside === void 0 ? void 0 : scopesAside.classList.add("d-none");
        }
    }
};
const createScopeElement = (scope) => {
    const wrapper = document.createElement("div");
    const title = document.createElement("h3");
    const list = document.createElement("ul");
    wrapper.classList.add("integration__scope-wrapper");
    title.classList.add("integration__scope-subtitle");
    title.innerHTML = scope.label;
    list.classList.add("integration__scope-list");
    scope.features.forEach(feature => {
        const item = document.createElement("li");
        item.classList.add(feature.enabled ? "check" : "noCheck");
        item.innerHTML = feature.label;
        list.appendChild(item);
    });
    wrapper.appendChild(title);
    wrapper.appendChild(list);
    return wrapper;
};
